import useTranslation from '../../hooks/useTranslation';
import React from 'react';

import style from './index.style';
import Link from 'next/link';

export default function UpsellAidify() {
  const { TRANSLATIONS, translationsParameters, locale } = useTranslation();

  return (
    <div className="w-100">
      <div className="aidify-container ta-c d-f fd-c">
        <h3>{TRANSLATIONS.pricing.upsell.title}</h3>
        <p className="aidify-subtitle">
          {translationsParameters(TRANSLATIONS.pricing.upsell.subtitle, [
            <span key={'t0'} className={'bold'}>
              Aidify
            </span>,
            <span key={'t1'} className={'bold'}>
              {TRANSLATIONS.pricing.upsell.t1}
            </span>,
            <span key={'t2'} className={'bold'}>
              {TRANSLATIONS.pricing.upsell.t2}
            </span>,
            <Link
              href={
                locale === 'it_IT'
                  ? 'https://www.aidify.cx/it'
                  : 'https://www.aidify.cx/'
              }
              passHref
              key={'link'}
            >
              <a
                className="aidify-link"
                target={'_blank'}
                rel="noopener noreferrer"
              >
                {TRANSLATIONS.pricing.upsell.tryIt}
              </a>
            </Link>,
          ])}
        </p>
      </div>
      <style jsx>{style}</style>
    </div>
  );
}
